<template>
  <div v-if="invoices">
    <b-table-simple striped bordered>
      <b-tbody>
        <b-tr>
          <b-th>#</b-th>
          <b-th>Amount</b-th>
          <b-th>Type</b-th>
          <b-th>Payment</b-th>
          <b-th>Status</b-th>
          <b-th>Operations</b-th>
        </b-tr>
        <b-tr v-for="(invoice, index) in invoices" :key="index">
          <b-td :class="` text-center pt-3  ${InvoiceColor(invoice.status)}`">
            <i
              :class="
                `fa mt-2 ${
                  invoice.type === InvoiceType.CREDIT
                    ? 'fa-arrow-down'
                    : 'fa-arrow-up'
                }`
              "
            ></i>
            {{ invoice.id }}
          </b-td>
          <b-td>
            <div class="d-flex">
              <input
                type="text"
                id="query"
                v-model="invoices[index].amount"
                placeholder="Enter the amount"
                class="form-control"
              />
              <span class="label fw-bold p-2 ">KWD</span>
            </div>
            <span class="error">{{ invoice.validationMessage }}</span>
          </b-td>
          <b-td>
            <b-select
              v-model="invoice['type']"
              class="border-radius-0 text-uppercase"
            >
              <b-select-option :value="InvoiceType.CREDIT">{{
                InvoiceType.CREDIT
              }}</b-select-option>
              <b-select-option :value="InvoiceType.DEBIT">{{
                InvoiceType.DEBIT
              }}</b-select-option>
            </b-select>
          </b-td>
          <b-td>
            <b-select
              v-model="invoice['payment_type']"
              class="border-radius-0 text-uppercase"
            >
              <b-select-option :value="InvoicePaymentType.CASH">{{
                InvoicePaymentType.CASH
              }}</b-select-option>
              <b-select-option
                v-if="InvoiceType.CREDIT"
                :value="InvoicePaymentType.ONLINE"
              >
                {{ InvoicePaymentType.ONLINE }}
              </b-select-option>
            </b-select>
          </b-td>
          <b-td>
            <b-select
              v-model="invoice['status']"
              class="border-radius-0 text-uppercase"
              placeholder="Label"
            >
              <b-select-option :value="InvoiceStatus.PENDING">{{
                InvoiceStatus.PENDING
              }}</b-select-option>
              <b-select-option :value="InvoiceStatus.PAID">
                {{ InvoiceStatus.PAID }}
              </b-select-option>
              <b-select-option :value="InvoiceStatus.CANCELED">{{
                InvoiceStatus.CANCELED
              }}</b-select-option>
            </b-select>
          </b-td>
          <b-td>
            <div class=" d-flex justify-content-around">
              <b-button
                @click="deleteInvoice(index)"
                v-b-modal.modal-delete
                variant="danger"
                size="sm"
              >
                <i class="las la-trash fa-lg"></i>
              </b-button>
              <b-button
                v-if="
                  invoice.type === InvoiceType.CREDIT &&
                    invoice.payment_type === InvoicePaymentType.ONLINE &&
                    invoice.external_link
                "
                @click="() => copyToClipboard(invoice.external_link)"
                variant="primary"
                size="sm"
              >
                <i class="las la-link fa-lg"></i>
              </b-button>
            </div>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td colspan="10">
            <b-button @click="addInvoice" class="btn-sm btn-success"
              ><i class="fa fa-plus"></i> Add Invoice
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-modal
      id="modal-delete"
      title="Confirm Delete"
      @ok="confirmDelete"
      ok-title="Yes, Delete"
      cancel-title="Cancel"
      ok-variant="danger"
      centered
    >
      <p>Are you sure you want to delete this invoice permanently?</p>
    </b-modal>
  </div>
</template>

<style scoped></style>
<script>
import {
  InvoiceColor,
  InvoicePaymentType,
  InvoiceStatus,
  InvoiceType
} from "@/config/Invoices";
import { deleteInvoice } from "@/API/InvoicesAPIs";
import Snackbar from "node-snackbar";
export default {
  name: "InvoicesList",
  props: ["invoicesData", "businessId", "branchId", "reservationId"],
  data() {
    return {
      deletedItem: null,
      invoices: [],
      invoiceModel: {
        amount: 0,
        note: "",
        type: InvoiceType.CREDIT,
        status: InvoiceStatus.PENDING,
        payment_type: InvoicePaymentType.CASH,
        invoice_for_id: null,
        business_id: null,
        branch_id: null,
        validationMessage: ""
      },
      emptyInvoice: ""
    };
  },
  computed: {
    InvoicePaymentType() {
      return InvoicePaymentType;
    },
    InvoiceType() {
      return InvoiceType;
    },
    InvoiceStatus() {
      return InvoiceStatus;
    }
  },
  mounted() {
    this.invoices = Array.isArray(this.invoicesData) ? this.invoicesData : [];
    this.invoiceModel.branch_id = this.branchId;
    this.invoiceModel.business_id = this.businessId;
    this.emptyInvoice = JSON.stringify(this.invoiceModel);
    if (!this.reservationId) this.addInvoice();
  },
  methods: {
    InvoiceColor,
    addInvoice() {
      this.invoices.push(JSON.parse(this.emptyInvoice));
    },
    async deleteInvoice(index) {
      this.deletedItem = index;
    },
    async confirmDelete() {
      if (this.deletedItem !== null && this.deletedItem !== undefined) {
        let invoice = this.invoices[this.deletedItem];
        if (!invoice) {
          this.deletedItem = null;
          return;
        }
        let shouldConfirm = !!invoice.id;

        if (shouldConfirm) {
          try {
            const requestData = {
              id: invoice.id,
              businessId: this.businessId,
              branchId: this.branchId
            };

            await deleteInvoice(requestData);
            this.invoices.splice(this.deletedItem, 1);
            this.deletedItem = null;

            Snackbar.show({
              text: "Deleted Successfully",
              pos: "top-center",
              actionText: "x",
              duration: 3000,
              actionTextColor: "#fff",
              backgroundColor: "#28a745"
            });
          } catch (error) {
            Snackbar.show({
              text:
                error.response?.data?.message ||
                "An unexpected error occurred.",
              pos: "top-center",
              actionText: "x",
              duration: 3000,
              actionTextColor: "#fff",
              backgroundColor: "#dc3545"
            });
          }
        }
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          Snackbar.show({
            text: "Copied to clipboard",
            pos: "top-center",
            actionText: "x",
            duration: 3000,
            actionTextColor: "#fff",
            backgroundColor: "#28a745"
          });
        })
        .catch(err => {
          Snackbar.show({
            text: "Could not copy to clipboard.",
            pos: "top-center",
            actionText: "x",
            duration: 3000,
            actionTextColor: "#fff",
            backgroundColor: "#dc3545"
          });
        });
    }
  },
  watch: {
    invoicesData: {
      deep: true,
      handler(value) {
        this.invoices = Array.isArray(value) ? value : [];
      }
    },
    invoices: {
      deep: true,
      handler(value) {
        if (!Array.isArray(value)) {
          this.invoices = [];
        }
        this.$emit("updateInvoices", this.invoices);
      }
    }
  }
};
</script>
